import { call, put, select, takeLatest, take, race } from "redux-saga/effects";
import { delay } from "redux-saga";
import get from "lodash.get";
import { history } from "../store";

import { postFields, postFields1981, postWorkItem, putWorkItem, changeStateClonedWorkitem } from "./Api";
import actions from "../actions/actionTypes";
import {
  selectInitializeResponse,
  selectCurrentStateAbbr,
  selectFieldsResponse,
  selectCurrentWorkItem,
  selectFormFieldByName,
  selectFormFields,
  selectCurrentMiscFees,
  selectCurrentPre1981Data,
  selectEnterDataManually
} from "selector/initializeSelector";
import {
  fetchFieldsSuccessAction,
  fetchFieldsFailedAction,
  createWorkItemAction,
  createWorkItemSuccessAction,
  createWorkItemFailedAction,
  generateWorkItemReportSuccessAction,
  generateWorkItemReportFailedAction,
  sanitizeFieldsAction,
  changeInputValueAction,
  workItemReportInProgressAction,
  showFieldsLoader,
  hideFieldsLoader,
  showNextSection,
  hideNextSection,
  setSectionMessage,
  fetchFieldsAction,
  setMiscFeeValue,
  setPre1981DataValue,
  enableQuestionaireButtons
} from "actions/questionaireActions";
import {
  updateWorkItemAction
} from "actions/fetchWorkItemsActions";
import { sanitizeWorkitemFields } from "utils";
import { showLoader, hideLoader } from "actions/soleraLoaderActions";
import { apiRequestFailureAction } from "actions/requestActions";
import {
    setCurrentStateAction,
    setFormFieldsAction,
    enterDataManually
} from "actions/workItemsActions";
import { selectUserId } from "selector/authSelectors";
import { getCurrentExternalId } from "selector/userSelectors";
import {
  minDateSymbol,
  maxDateSymbol,
  startOfDay,
  isValidDate
} from "utils/dates";
import fetchSaga from "./fetchSaga";
import { getFieldByKey } from "utils";
import * as WorkItem from "domain/WorkItem";

export function* fetchFieldsSaga(action) {
  try {
    yield put(showFieldsLoader());

    let miscFees = yield select(selectCurrentMiscFees);
    if(miscFees !== undefined && miscFees.length > 0){
      const claimTypeValue = action.payload.filter(a => a.key === "cOwnerRet")[0].value
      let claimTypeItems = [];
      let value = "";
      switch(claimTypeValue){
        case "No":
          value = "Insurer Retained";
          claimTypeItems.push("Insurer Retained");
          break;
        case "Yes":
          value = "Owner Retained";
          claimTypeItems.push("Owner Retained");
          break;
        case "Dual":
        default:
          claimTypeItems.push("Insurer Retained");
          claimTypeItems.push("Owner Retained");
          break;
      }
      miscFees.forEach(a => {
        a.filter(b => b).filter(c => c.sequence.includes("claimType"))[0].items = claimTypeItems;
        a.filter(b => b).filter(c => c.sequence.includes("claimType"))[0].value = claimTypeValue === "Dual" ? "" : value;
      });
    }
    yield put(setMiscFeeValue(miscFees));

    action.payload.onNext = true;
    let messages = { messages: [] };
    const state = yield select(selectCurrentStateAbbr);
    let CAValidation = false;
    let addressFilled, zipFilled, MakeYearValid = true;
    let sectionMessage = "";
    action.payload.forEach(field => {
      switch(field.key){
        case "cAddress":
          if(field.type !== "Phantom")
            addressFilled = field.value === "" ? false : true;
          break;
        case "cRegZip":
          if(field.type !== "Phantom")
            zipFilled = field.value === "" ? false : true;
          break;
        case "cACVAddress":
          addressFilled = field.value === "" ? false : true;
          break;
        case "cACVRegZip":
          zipFilled = field.value === "" ? false : true;
          break;
        case "cYear":
          MakeYearValid = field.value === "" ? true : checkIsValid(field.value);
          break;
      }
      if (state === "CA") {
        if (["cvin", "clicplate"].indexOf(field.key.toLowerCase()) >= 0) {
          if (field.value !== "") {
            CAValidation = true;
          }
        } else if (field.required === "True" && field.value === "") {
          messages.messages.push({
            key: null,
            messageText: `${field.name} is required`,
            type: "warning"
          });
        }
      } else {
        if (field.required === "True" && field.value === "") {
          messages.messages.push({
            key: null,
            messageText: `${field.name} is required`,
            type: "warning"
          });
        }
      }
      if(field.key === "cACV" && field.required === "False"){
        let value = field.value === "" ? 0 : field.value;
        if (value > 0){
          sectionMessage = "";
          if(!addressFilled || !zipFilled){
            messages.messages.push({
              key: null,
              messageText: `Street Address and Registered Zip are required to calcate Sales Tax`,
              type: "warning"
            });
          }
        }else{
          sectionMessage = "*ACV is needed to calculate Sales Tax.  No sales tax will be calculated";
        }
      }
      if(field.mask !== null && field.value !== ""){
        var regExp = new RegExp(field.mask);
        if(!regExp.test(field.value)){
          messages.messages.push({
            key: null,
            messageText: `${field.name} doesn't match the field mask`,
            type: "warning"
          });
        }
      }
    });
    yield put(setSectionMessage(sectionMessage));
    if (state === "CA" && !CAValidation) {
      messages.messages.push({
        key: null,
        messageText: "Please enter valid VIN or License Plate Number",
        type: "warning"
      });
    }

    const lastRegistrationField = action.payload.find(
      x => x.key === "dLastReg"
    );
    const lossDateField = action.payload.find(x => x.key === "dLossDate");
    const lastRegistrationDate = get(lastRegistrationField, "value");
    const lossDate = get(lossDateField, "value");
    if (lastRegistrationDate && !isValidDate(lastRegistrationDate)) {
      messages.messages.push({
        key: null,
        messageText: `Invalid date for '${lastRegistrationField.name}'`,
        type: "error"
      });
    } else if (lossDate && !isValidDate(lossDate)) {
      messages.messages.push({
        key: null,
        messageText: `Invalid date for '${lossDateField.name}'`,
        type: "error"
      });
    } else if (lastRegistrationDate && lossDate) {
      const lastRegistrationDayDate = startOfDay(lastRegistrationDate);
      const lossDayDate = startOfDay(lossDate);

      if (lastRegistrationDayDate > lossDayDate) {
        messages.messages.push({
          key: null,
          messageText: `Incorrect dates: '${lastRegistrationField.name}' must be prior to '${lossDateField.name}'`,
          type: "error"
        });
      }
    }
    let zipCodeField = getFieldByKey(action.payload, "cRegZip");
    if (zipCodeField == undefined){
      zipCodeField = getFieldByKey(action.payload, "cACVRegZip");
    }
    if (zipCodeField && typeof zipCodeField.type === "string" && zipCodeField.type.toLowerCase() === "text" && !WorkItem.isValidZip(zipCodeField.value)) {
      messages.messages.push({
        key: null,
        messageText: "Invalid Zip Code",
        type: "error"
      });
    }
    if (!MakeYearValid) {
      messages.messages.push({
          key: null,
          messageText: `Incorrect Model / Year`,
          type: "error"
      });
    }

    if (messages.messages.length) {
      yield put(hideFieldsLoader());
      yield put(apiRequestFailureAction(messages));
      return;
    }
    const { messageHeader } = yield select(selectInitializeResponse);
    const body = {
      dualFeesRequest: [{ fields: action.payload }],
      messageHeader
    };
    const fetchFn = (action.meta && action.meta.fetchFn) || postFields;
    const response = yield call(fetchSaga, fetchFn, { state, body });

    yield put(
      sanitizeFieldsAction(response.dualFeesResponse[0].fields.fieldDetails)
    );
    const [success, error] = yield race([
      take(actions.SANITIZE_FIELDS_SUCCESS),
      take(actions.SANITIZE_FIELDS_FAILURE)
    ]);

    if (error) throw error;

    const payload = { ...response };
      let fields = success.payload;
    if (response.dualFeesResponse.length > 1) {
      fields = fields.map(field =>
        field.key === "cOwnerRet" ? { ...field, value: "Dual" } : field
      );
    }
    payload.fields = { fieldDetails: fields };
    yield put(fetchFieldsSuccessAction(payload));
    // fields = { ...fields, ...body.fields };
    // delete fields.onNext;
    // fields = Object.values(fields);
    const localFields = action.payload;
    fields = fields.map(field => {
      const localIndex = localFields.findIndex(
        x => x.key === field.key && x.isInitialize === "True"
      );
      if (localIndex >= 0) {
        const localField = localFields[localIndex];
        const incomingValidValues = get(field, "validValues.value", "").split(
          "|"
        );
        const currentValueInIncomingValidValues = incomingValidValues.includes(
          localField.value
        );

        if (currentValueInIncomingValidValues) {
          return { ...field, value: localField.value };
        }
      }
      return field;
    });
    fields = fields
      .map(e => e["key"])
      .map((e, i, final) => final.indexOf(e) === i && i)
      .filter(e => fields[e])
      .map(e => fields[e]);

    yield put(setFormFieldsAction(fields));
    yield put(showNextSection());
  } catch (error) {


      if (document.getElementById("cMake").value != "Select Make" && document.getElementById("cYear").value != "") {
          const pre1981data = yield select(selectEnterDataManually);
          let res;
          if (!pre1981data) {
              res = window.confirm("Do you want to enter the information manually?");
          }
          else {
              res = true;
          }
          if (res) {
              yield put(enterDataManually(res));
              const state = yield select(selectCurrentStateAbbr);
              const { messageHeader } = yield select(selectInitializeResponse);
              const body = {
                  dualFeesRequest: [{ fields: action.payload }],
                  messageHeader
              };
              const fetchFn = (action.meta && action.meta.fetchFn) || postFields1981;
              try {
                  const response = yield call(fetchSaga, fetchFn, { state, body });
                  yield put(
                      sanitizeFieldsAction(response.dualFeesResponse[0].fields.fieldDetails)
                  );

                  const [success, error] = yield race([
                      take(actions.SANITIZE_FIELDS_SUCCESS),
                      take(actions.SANITIZE_FIELDS_FAILURE)
                  ]);

                  if (error) throw error;

                  const payload = { ...response };
                  let fields = success.payload;
                  if (response.dualFeesResponse.length > 1) {
                      fields = fields.map(field =>
                          field.key === "cOwnerRet" ? { ...field, value: "Dual" } : field
                      );
                  }
                  payload.fields = { fieldDetails: fields };
                  yield put(fetchFieldsSuccessAction(payload));
                  const localFields = action.payload;
                  fields = fields.map(field => {
                      const localIndex = localFields.findIndex(
                          x => x.key === field.key && x.isInitialize === "True"
                      );
                      if (localIndex >= 0) {
                          const localField = localFields[localIndex];
                          const incomingValidValues = get(field, "validValues.value", "").split(
                              "|"
                          );
                          const currentValueInIncomingValidValues = incomingValidValues.includes(
                              localField.value
                          );

                          if (currentValueInIncomingValidValues) {
                              return { ...field, value: localField.value };
                          }
                      }
                      return field;
                  });


                  const vehicle = response.vehicle;

                  const pre1981set=vehicle.map(function (obj) {
                      var rObj = {};
                      rObj["state"] = state;
                      rObj["sequence"] = obj.sequence;
                      rObj["name"] = obj.name;
                      rObj["key"] = obj.key;
                      rObj["label"] = obj.key;
                      //rObj["value"] = obj.value.includes("|") ? obj.value.split("|")[0] : "";
                      rObj["value"] = "";
                      var validValues = {};
                      validValues["value"] = obj.value.includes("|") ? obj.value : "";
                      validValues["text"] = obj.value.includes("|") ? obj.value: "";
                      rObj["validValues"] = validValues;
                      rObj["type"] = obj.value.includes("|") ? "DropDown" : "Text";
                      rObj["helpText"] = obj.name;
                      rObj["mask"] = null;
                      rObj["maxLength"] = null;
                      rObj["required"] = obj.required;
                      rObj["groupField"] = "pre1981";
                      rObj["isShowMain"] = "False";
                      rObj["isShowReport"] = "False";
                      rObj["isInitialize"] = "False";
                      rObj["disabled"] = null;
                      return rObj;
                  });


                  yield put(setPre1981DataValue(pre1981set));

                  fields = fields
                      .map(e => e["key"])
                      .map((e, i, final) => final.indexOf(e) === i && i)
                      .filter(e => fields[e])
                      .map(e => fields[e]);

                  yield put(setFormFieldsAction(fields));

              }
              catch (error) {
                  yield put(enterDataManually(false));
              }
          }
      }
      else {
          yield put(enterDataManually(false));
      }
    yield put(fetchFieldsFailedAction(error));
  }
  yield put(hideFieldsLoader());
}

export function* buildFeesRequest(fieldDetails, status) {
  let request = yield select(selectFieldsResponse);
  let feesIns = null;
  let feesOwn = null;
  let miscInsSequence = 0;
  let miscOwnSequence = 0;
  const state = yield select(selectCurrentStateAbbr);

  const miscFeesFields = yield select(selectCurrentMiscFees);

  if (Object.keys(miscFeesFields).length > 0) {
    feesIns = {
        fees: [{
        feeType:"Miscellaneous Fees",
        sequence: "4",
        description: []
      }]
    };
    feesOwn = {
        fees: [{
        feeType:"Miscellaneous Fees",
        sequence: "4",
        description: []
      }]
    };

    for(var key in miscFeesFields){
      const value = miscFeesFields[key].filter(a => a.sequence.includes("claimType"))[0].value;
      const claimType = typeof value === "string" ? value : value.value;
      if(claimType === "Insurer Retained")
      {
        miscInsSequence ++;
        feesIns.fees[0].description.push(
          {
            name:"MiscFee",
            sequence: miscInsSequence,
            key:"MiscFee",
            proratedAmount: miscFeesFields[key].filter(a => a.sequence.includes("feeAmount"))[0].value,
            type: "One-Time",
            helpText: miscFeesFields[key].filter(a => a.sequence.includes("feeName"))[0].value,
            level: state,
            fullAmount: miscFeesFields[key].filter(a => a.sequence.includes("feeAmount"))[0].value
          }
        );
      } else if(claimType === "Owner Retained"){
        miscOwnSequence ++;
        feesOwn.fees[0].description.push(
          {
            name:"MiscFee",
            sequence: miscOwnSequence,
            key:"MiscFee",
            proratedAmount: miscFeesFields[key].filter(a => a.sequence.includes("feeAmount"))[0].value,
            type: "One-Time",
            helpText: miscFeesFields[key].filter(a => a.sequence.includes("feeName"))[0].value,
            level: state,
            fullAmount: miscFeesFields[key].filter(a => a.sequence.includes("feeAmount"))[0].value
          }
        );
      }
    }
    }

    let vehicledata;
    const pre1981Manually = yield select(selectEnterDataManually);

    if (pre1981Manually) {
        let pre1981info = [];
        var rvehicleVIN = {};
        var rvehicleMAKE = {};
            request.fields.fieldDetails.forEach(a => {
                    if (a.key === "cVin") {
                        rvehicleVIN["name"] = "Vehicle Number";
                        rvehicleVIN["key"] = "VehicleNumber";
                        rvehicleVIN["value"] = a.value;
                        rvehicleVIN["sequence"] = "2";
                        rvehicleVIN["required"] = "true";
                    }
                    if (a.key === "cMake") {
                        rvehicleMAKE["name"] = "Vehicle Make";
                        rvehicleMAKE["key"] = "VehicleMake";
                        rvehicleMAKE["value"] = a.value;
                        rvehicleMAKE["sequence"] = "5";
                        rvehicleMAKE["required"] = "true";
                    }
                });
        
        let pre1981Data = yield select(selectCurrentPre1981Data);
        let vehicleMake = false;
        let vehicleVIN = false;
        pre1981Data.forEach(field => {
            if (field.key === 'cVin') {
                vehicleVIN=true;
            }
            if (field.key === 'cMake') {
                vehicleMake = true;
            }
                var rObj = {};
                rObj["name"] = field.name;
                rObj["key"] = field.key;
                if (field.value.value !== undefined) {
                    rObj["value"] = field.value.value;
                }
                else {
                    rObj["value"] = field.value;
                }
                rObj["sequence"] = field.sequence;
                rObj["required"] = field.required;
                pre1981info.push(rObj);
        });
        if (!vehicleVIN) {
            pre1981info.push(rvehicleVIN);
        }
        if (!vehicleMake) {
            pre1981info.push(rvehicleMAKE);
        }
        
        vehicledata = pre1981info;
    }

  const externalIdObject = yield select(getCurrentExternalId);
    if (request) {
        if (pre1981Manually) {
            request.vehicle = vehicledata;
        }
    request.dualFeesResponse.forEach( a => {
      if((a.fields.fieldDetails.filter(b => b.key === "cOwnerRet" && b.value === "No").length === 1 )){
        a.fees = miscInsSequence > 0 ? feesIns : null;
      }
      if((a.fields.fieldDetails.filter(b => b.key === "cOwnerRet" && b.value === "Yes").length === 1 )){
        a.fees = miscOwnSequence > 0 ? feesOwn : null;
      }
    });
    request.dualFeesRequest = [{ fields: fieldDetails, fees: null }];
    request.messageHeader.customerId = yield select(selectUserId);
    request.messageHeader.status = status || "IN PROGRESS";
    request.messageHeader.externalId = get(externalIdObject, "id");
  } else {
      let workItem = yield select(selectCurrentWorkItem);
      if (!pre1981Manually) {
          vehicledata = workItem.vehicle;
      }
    workItem.dualFeesResponse.forEach( a => {
      if (a.fees === null){
        if((a.fields.fieldDetails.filter(b => b.key === "cOwnerRet" && b.value === "No").length === 1 )){
          a.fees = miscInsSequence > 0 ? feesIns : null;
        }
        if((a.fields.fieldDetails.filter(b => b.key === "cOwnerRet" && b.value === "Yes").length === 1 )){
          a.fees = miscOwnSequence > 0 ? feesOwn : null;
        } 
      }
    });
    request = {
      messageHeader: {
        customerId: workItem.attributes.customerId,
        status: status || workItem.attributes.status,
        cid: get(workItem, "attributes.cid"),
        externalId: get(externalIdObject, "id")
      },
      dualFeesRequest: [{ fields: fieldDetails, fees: null }],
        dualFeesResponse: workItem.dualFeesResponse,
        vehicle: vehicledata,
      location: workItem.location,
      messages: workItem.messages
    };
    }

  return request;
}

export function* createWorkItemSaga(action) {
  try {
    let miscFees = yield select(selectCurrentMiscFees);
    var miscFeeValid = true;
    if(miscFees !== undefined && miscFees.length > 0){
      miscFees.forEach(miscFee => {
        miscFee.forEach(field =>{
          if (field.value == "")
            miscFeeValid = false;
        });
      });
    }
    if(!miscFeeValid){
      let messages = { messages: [] };
      messages.messages.push({
        key: null,
        messageText: `All Miscellaneous fees information is required.`,
        type: "warning"
      });
      if(action.payload.status === "COMPLETED"){
        yield put(hideLoader());
      }
        yield put(apiRequestFailureAction(messages));
        yield put(enableQuestionaireButtons());
      return;
    }

      let pre1981Data = yield select(selectCurrentPre1981Data);
      
      var pre1981DataValid = true;
      if (pre1981Data !== undefined && pre1981Data.length > 0) {
          pre1981Data.forEach(field => {
              if (field.value == "")
                  pre1981DataValid = false;
          });
      }

      if (!pre1981DataValid) {
          let messages = { messages: [] };
          messages.messages.push({
              key: null,
              messageText: `All Vehicle Data information is required.`,
              type: "warning"
          });
          if (action.payload.status === "COMPLETED") {
              yield put(hideLoader());
          }
          yield put(apiRequestFailureAction(messages));
          yield put(enableQuestionaireButtons());
          return;
      }

    let { status, fieldDetails } = action.payload;


    const body = yield call(buildFeesRequest, fieldDetails, status);
    const workItem = yield select(selectCurrentWorkItem);
    const state = yield select(selectCurrentStateAbbr);

    let apiFn = workItem ? putWorkItem : postWorkItem;
    let args = workItem
      ? { workItemId: workItem.workItemId, body, state }
      : { state, body };

    const returnRawResponse = true;
    const response = yield call(fetchSaga, apiFn, args, returnRawResponse);

    const newWorkItem = yield call(response.json.bind(response));
    if (response.status === 200 && newWorkItem.attributes.status === "COMPLETED") {
      yield put(createWorkItemSuccessAction(newWorkItem));
      if (action.redirect) yield call([history, "push"], "/");
    } else if (response.status === 202 || newWorkItem.attributes.status === "IN PROGRESS") {
      yield put(workItemReportInProgressAction(newWorkItem));
      return yield call([history, "push"], "/");
    }
  } catch (error) {
    yield put(createWorkItemFailedAction(error));
  }
}

export function* generateWorkItemReportSaga(action) {
  yield put(showLoader());
  try {
    const workItem = yield select(selectCurrentWorkItem);
    const state = yield select(selectCurrentStateAbbr);
    if (workItem) {
      const body = yield call(buildFeesRequest, action.payload, "COMPLETED");
      const { workItemId } = workItem;
      const returnRawResponse = true;
      const response = yield call(
        fetchSaga,
        putWorkItem,
        {
          workItemId,
          state,
          body
        },
        returnRawResponse
      );

      const newWorkItem = yield call(response.json.bind(response));
      if (response.status === 200 && newWorkItem.attributes.status === "COMPLETED") {
        yield put(generateWorkItemReportSuccessAction(newWorkItem));
      } else if (response.status === 202 || response.status === 504 || newWorkItem.attributes.status === "IN PROGRESS") {
        yield put(workItemReportInProgressAction(newWorkItem));
        yield put(hideLoader());
        return yield call([history, "push"], "/");
      }
    } else {
      yield put(createWorkItemAction(action.payload, "COMPLETED", false));

      const raceActions = yield race([
        take(actions.CREATE_WORK_ITEM_SUCCESS),
        take(actions.CREATE_WORK_ITEM_FAILED),
        take(actions.WORKITEM_REPORT_IN_PROGRESS)
      ]);
      const error = get(raceActions, "[1].payload");
      if (error) throw error;

      const inProgressAction = raceActions[2];
      if (inProgressAction) {
        yield put(hideLoader());
        return yield call([history, "push"], "/");
      }
    }

    yield call([history, "push"], "/Summary");
    yield put(hideLoader());
  } catch (error) {
    yield put(generateWorkItemReportFailedAction(error.stack));
    yield put(hideLoader());
  }
}

function* cancelCreateWorkItemSaga() {
  yield call([history, "push"], "/");
}

export function* requestChangeInputValueSaga({
  payload: { name: fieldName, value, field }
}) {
        if (!["dLossDate", "dLastReg"].includes(fieldName)) {
            return yield put(changeInputValueAction(fieldName, value));
        }

        if (isNaN(value)) {
            value = new Date(Date.parse(field.value + " UTC")).toLocaleString()
        }

        const otherFieldName = fieldName === "dLossDate" ? "dLastReg" : "dLossDate";
        const otherField = yield select(selectFormFieldByName(otherFieldName));
        const today = new Date();

        if (value && value.constructor === Date && value > today) {
            value = today;
        }

        if (!otherField) return yield put(changeInputValueAction(fieldName, value));

        const symbol = fieldName === "dLastReg" ? minDateSymbol : maxDateSymbol;
        otherField[symbol] = isValidDate(value)
            ? value
            : symbol === maxDateSymbol && today;

        yield put(
            changeInputValueAction(otherFieldName, otherField.value, otherField)
        );
        yield put(changeInputValueAction(fieldName, value));
}

export function* changeInputValueSaga({ payload: { name, value, field } }) {
  const formFields = yield select(selectFormFields);
  const fieldObject = formFields.find(x => x.key === name);
  if (fieldObject.groupField === "First") {
    yield put(hideNextSection());
  }
  const updatedFields = formFields.map(x => {
    if (x.key === name)
    {
      value = Object.prototype.toString.call(value) === "[object Date]" ? value.toISOString().split('T')[0] : value;
      return { ...x, ...field, value }
    }
    else
    {
      return x
    }
  });

  if (fieldObject.isInitialize === "True") {
    yield put(setFormFieldsAction(updatedFields));
  } else {
    yield put(fetchFieldsAction(updatedFields));
  }
}

export function* changeStateCloneWISaga(data){
  yield put(showLoader());
  const workItem = yield call(fetchSaga, changeStateClonedWorkitem, {workitemId: data.workitemId, state: data.state.value});
  yield put(hideLoader());
  yield call([history, "push"], "/");
  yield call(delay, 0);

  yield put(
    setCurrentStateAction({
      abbr: null,
      name: null
    })
  );

  yield put(updateWorkItemAction(workItem));

  let rawFields = get(workItem, "dualFeesResponse[0].fields.fieldDetails", []);
  if (workItem.dualFeesResponse.length > 1) {
    rawFields = rawFields.map(field =>
      field.key === "cOwnerRet" ? { ...field, value: "Dual" } : field
    );
  }
  const fields = sanitizeWorkitemFields(rawFields);
  yield put(setFormFieldsAction(fields));

  yield call(delay, 0);

  yield call([history, "push"], "/questionnaire");
  
}

function checkIsValid(_data) {
    var _thisYear = new Date().getFullYear();

    if (_data.length != 4) return false;
    if (!_data.match(/\d{4}/)) return false;
    if (parseInt(_data) > _thisYear || parseInt(_data) < 1900)
        return false;
    return true;
}

export const questionaireSagas = [
  takeLatest(actions.FETCH_FIELDS, fetchFieldsSaga),
  takeLatest(actions.CREATE_WORK_ITEM, createWorkItemSaga),
  takeLatest(actions.CANCEL_WORKITEM, cancelCreateWorkItemSaga),
  takeLatest(actions.GENERATE_WORKITEM_REPORT, generateWorkItemReportSaga),
  takeLatest(actions.REQUEST_CHANGE_INPUT_VALUE, requestChangeInputValueSaga),
  takeLatest(actions.CHANGE_INPUT_VALUE, changeInputValueSaga),
  takeLatest(actions.CHANGE_STATE_CLONE_WORKITEM, changeStateCloneWISaga),
];
